import { defineMessages } from 'react-intl'

export const strings = defineMessages({
  header: {
    id: 'BookBuilder.header',
    defaultMessage: 'Customize Guestbook',
  },
  title: {
    id: 'BookBuilder.title',
    defaultMessage: 'Book Title',
  },
  coverHeading: {
    id: 'BookBuilder.coverHeading',
    defaultMessage: 'Cover Options',
  },
  coverFont: {
    id: 'BookBuilder.coverFont',
    defaultMessage: 'Cover Font',
  },
  coverFontSize: {
    id: 'BookBuilder.coverFontSize',
    defaultMessage: 'Cover Font Size',
  },
  cropLabel: {
    id: 'BookBuilder.cropLabel',
    defaultMessage: 'Cover Photo',
  },
  pageHeading: {
    id: 'BookBuilder.pageHeading',
    defaultMessage: 'Page Options',
  },
  pageFont: {
    id: 'BookBuilder.pageFont',
    defaultMessage: 'Page Font',
  },
  pageFontSize: {
    id: 'BookBuilder.pageFontSize',
    defaultMessage: 'Page Font Size',
  },
  entriesPerPage: {
    id: 'BookBuilder.entriesPerPage',
    defaultMessage: 'Entries Per Page',
  },
})
